import { RiTestTubeLine } from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineSetting } from "@onemind-services-llc/react-icons-ng/ai";
import { MdOutlineCloudDone } from "@onemind-services-llc/react-icons-ng/md";
import { SimpleList } from "@/components/list";

export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Emulation, Simulation, and Real-World Testing",
  list: [
    {
      icon: RiTestTubeLine,
      title: "Emulation Features",
      content: (
        <SimpleList
          points={[
            "Provides a replica of real network devices, applications, or systems using virtualized environments. ",
            "Ideal for testing network automation, security policies, and performance tuning before deployment. ",
            "Used for software-defined networking (SDN), cloud migration testing, and troubleshooting. ",
          ]}
        />
      ),
    },
    {
      icon: AiOutlineSetting,
      title: "Simulation Features",
      content: (
        <SimpleList
          points={[
            "Helps model and analyze complex systems such as AI, machine learning, and cloud computing architectures.",
            "Useful in industries like telecommunications, automotive, and cybersecurity for performance analysis.",
            "Supports predictive testing by simulating different user loads, failures, and environmental conditions.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineCloudDone,
      title: "Real-World Testing Features",
      content: (
        <SimpleList
          points={[
            "Provides real-time insights into how a product or network performs under actual working conditions.",
            "Ensures that latency, bandwidth, security, and failover mechanisms function correctly.",
            "Helps identify unexpected performance issues that may not be visible in emulated or simulated environments.",
          ]}
        />
      ),
    },
  ],
};
